import React, { Component, useRef, useEffect, useState, lazy, Suspense } from 'react';

import {
  BrowserRouter,
  Route,
  useLocation,
  // location,
  Routes,
  Navigate,
} from 'react-router-dom';


import ReactPixel from 'react-facebook-pixel';

import LanguageWrapper from "./99_untils/LanguageWrapper";
import AuthTokenContext from "./99_untils/AuthTokenContext";

import './App.css';
import './99_untils/i18n/';
import { useTranslation } from 'react-i18next';

import Home from './Home/Home';
import MiniGameSelect from './02_minigame/MiniGameSelect';
import MiniGameLanding from './02_minigame/MiniGameLanding';
import MiniGamePlay from './02_minigame/MiniGamePlay';

// import NotFound from './NotFound/NotFound';
// import Home from './Home/Home';

const optionsReactPixel = { autoConfig: true, debug: false }; // Optional options


const routes = [
  { path: '/:lang', name: 'Home', component: Home },
  { path: '/:lang/minigame', name: 'minigamelanding', component: MiniGameLanding },
  { path: '/:lang/minigameselect', name: 'minigameselect', component: MiniGameSelect },
  { path: '/:lang/minigameplay', name: 'minigameplay', component: MiniGamePlay },
]

//const AppComponent = ({ location }) => {
// class App extends React.Component {
export default function App(props) {

  const isMountedRef = useRef(false);
  const isLocationRef = useRef(null);
  const initReactPixelRef = useRef(null);

  const { i18n } = useTranslation();

  let curLang = i18n.language;
  const [isOpen, setIsOpen] = useState(false);

  // Auth token state management
  const [authToken, setAuthToken] = useState(null);
  const [isAuthChecked, setIsAuthChecked] = useState(false);
  const [authError, setAuthError] = useState(null);


  function ScrollToTop() {
    // const fullURL_JS = window.location.href;
    const { pathname } = useLocation();


    useEffect(() => {

      window.scrollTo(0, 0); // Scrolls to the top-left corner
      if (isLocationRef.current !== pathname) {
        console.log('App pathname changed ReactPixel.pageView:', pathname);
        ReactPixel.pageView();
        isLocationRef.current = pathname;
      }
    }, [pathname]); // Re-run effect whenever the URL pathname changes

    return null; // This component doesn't render anything
  }

  // Example in a component or effect that runs when the route updates
  // useEffect(() => {
  //   ReactPixel.pageView();
  // }, [location.pathname]); // assuming you have access to location from react-router-dom



  useEffect(() => {

    curLang = i18n.language;

  }, [i18n.language])


  useEffect(() => {
    isMountedRef.current = true;

    if(!initReactPixelRef.current) {
      ReactPixel.init(
        '1454020690066888',
        // advancedMatching, 
        optionsReactPixel
      );
      ReactPixel.pageView();
      initReactPixelRef.current = true;
    }

    return () => {
      isMountedRef.current = false;
    }
  }, [])

  return (
    <div>
      {/* <Suspense fallback={<LoadingIndicator />}> */}
      <AuthTokenContext.Provider value={{
        token: authToken,
        setToken: setAuthToken,
        isAuthChecked,
        setIsAuthChecked,
        authError,
        setAuthError
      }}>
        <BrowserRouter>
          <ScrollToTop />

          {/* <div className=''><h5>user token = {userAuthRefTesting}</h5></div> */}
          <Routes>
            {/* Redirect the root path to the default language (e.g., /en) */}
            <Route path="/" element={<Navigate to={`/${curLang}`} />} />
            <Route path='/:lang' element={<LanguageWrapper />}>
              {routes.map((route, index) => {
                const Component = route.component;
                return (
                  <Route
                    key={index}
                    path={route.path}
                    element={<Component />}
                  />
                );
              })}
            </Route>
          </Routes>
        </BrowserRouter>
      </AuthTokenContext.Provider>
      {/* </Suspense> */}
    </div>
  )

}

// export default App;
